import * as React from 'react';

import { CompareBanner } from '../../components/CompareBanner';
import { useApplicationContext } from '../../utils/applicationContext';
import { SliderModalLoadable, type TSliderModalProps } from './loadable';

type TSlides = TSliderModalProps['slides'];

const SLIDES_CONFIG_KEY = 'Newbuilding.CompareFlightTrap.Slides';

export const CompareBannerContainer = () => {
  const { config } = useApplicationContext();
  const [open, setOpen] = React.useState(false);

  const slides = config.get<TSlides>(SLIDES_CONFIG_KEY) ?? [];

  const handleClickOpen = React.useCallback(() => {
    setOpen(true);
  }, []);

  const handleClickClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <CompareBanner onClick={handleClickOpen} />

      {open && <SliderModalLoadable slides={slides} onClose={handleClickClose} />}
    </>
  );
};
